import { MemberDatasource } from './../../../global/datasources/member_datasource';
import { IMemberConfiguration } from './../../../global/configuration/member_configuration';
import { IPhxAxTitleAnnouncerDelegate } from './../../../global/types';
import { ICommand } from 'core-ts-types';
import { IMemberConfigurationDataType } from './../../../global/configuration/member_configuration';
import { IMemberDatasource } from './../../../global/datasources/member_datasource';

export class AnonymousLandingController {
  public models: {
    configuration: IMemberConfigurationDataType;
    data: IMemberDatasource;
  };

  constructor(
    private $state: angular.ui.IStateService,
    private restoreLocalAccountCommand: ICommand,
    loadMemberConfigurationCommand: ICommand,
    phxAxTitleAnnouncerDelegate: IPhxAxTitleAnnouncerDelegate,
    ngMemberConfiguration: IMemberConfiguration,
    ngMemberDatasource: MemberDatasource
  ) {
    this.models = {
      configuration: ngMemberConfiguration.read(),
      data: ngMemberDatasource.read()
    };
  }

  isModal(): boolean {
    const views: string[] = this.$state.current ? (this.$state.current as any).views : undefined;

    return views && !_.isEmpty(views['modal@landing']);
  }
}

angular.module('capability-ng-anonymous-landing').component('anonymousLanding', {
  templateUrl: 'lib/anonymous_landing/components/anonymous_landing/anonymous_landing.html',
  controller: AnonymousLandingController
});



// WEBPACK FOOTER //
// ./app/lib/anonymous_landing/components/anonymous_landing/anonymous_landing.ts